import { Language } from "./language.model";
import { Person } from "./person.model";
import { UserType } from "./user-type.model";

export class User {

    id?: number;
    /** Id del usuario de la sesión (el que inició sesión). Para no mostrar "Enmascarar" sobre sí mismo. */
    userSessionId?: number;
    active?: boolean;

    account?: string;
    language?: Language;
    languageId?: number;
    password?: string;
 
    profiles?: Array<string>;
    person?: Person;
    personId?: number;
    resetPassword?: boolean;
    userType?: UserType;
    userTypeId?: number;
    maskUser?: string;
    maskUserId?: number;

    //Propiedades extras
    isAssigned?: boolean;
    maskedUser?: User;
    currentUser?: User;
    /** Foto del usuario (URL). Viene del API en user/permissions. */
    photo?: string | null;
    /** Campo opcional del API (p. ej. datos extendidos del usuario). */
    status?: number | null;

    constructor(source: Partial<User>) {
        Object.assign(this, source);
    }
}
